// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ContainerTwoToneSvg from "@ant-design/icons-svg/es/asn/ContainerTwoTone";
import AntdIcon from '../components/AntdIcon';

var ContainerTwoTone = function ContainerTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ContainerTwoToneSvg
  }));
};

ContainerTwoTone.displayName = 'ContainerTwoTone';
export default React.forwardRef(ContainerTwoTone);